// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
//TODO: add typing
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';
import { Button, CheckboxField, customScrollStyles, Loader } from '@gem/ui-kit';

import { TextFormattingInput } from 'APP/components/TextFormattingInput/TextFormattingInput';
import { useCloseMediaMessageOnNavigation } from 'APP/main/PopupManager/Popups/MediaMessagePopup/hooks/useCloseMediaMessageOnNavigation';
import { useContextMenu } from 'APP/main/hooks/useContextMenu/useContextMenu';
import { PayloadType } from 'APP/model/message/messageModel.types';

import { ItemMedia } from './ItemMedia/ItemMedia';
import { MediaMessageAlbum } from './MediaMessageAlbum/MediaMessageAlbum';
import {
  IMediaMessagePopupPresenterParams,
  useMediaMessagePopupPresenter,
} from './MediaMessagePopup.presenter';
import styles from './MediaMessagePopup.styles.m.css';
import { MediaMessageSubmitMenu } from './MediaMessageSubmitMenu/MediaMessageSubmitMenu';

type IMediaMessagePopopProps = IMediaMessagePopupPresenterParams;

export const MediaMessagePopup: FC<ICommonPopupsProps<IMediaMessagePopopProps>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useMediaMessagePopupPresenter(props);
    const { popover, onContextMenu } = useContextMenu<HTMLButtonElement>();
    useCloseMediaMessageOnNavigation(props.popupInstance, props.params!.groupId);

    return (
      <Popup
        isOpened
        onClose={presenter.onClose}
        title={presenter.popupTitle}
        className={styles.container}
      >
        <div className={classNames(styles.content, customScrollStyles.container)}>
          {presenter.isLoading && (
            <div className={styles.loader}>
              <Loader color={'base'} />
            </div>
          )}

          {presenter.messagesPayloadsData.map((payloadData) => {
            return payloadData.payload.payloadType === PayloadType.Album ? (
              <MediaMessageAlbum
                key={payloadData.id}
                payload={payloadData.payload}
                onRemove={presenter.canBeRemove ? presenter.onDelete : undefined}
              />
            ) : (
              <ItemMedia
                key={payloadData.id}
                payload={payloadData.payload}
                onRemove={presenter.canBeRemove ? presenter.onDelete : undefined}
              />
            );
          })}
        </div>

        <div className={styles.footer}>
          {presenter.isShowSendMediaAsFile && (
            <CheckboxField
              className={styles.sendAsFileCheckbox}
              onChange={presenter.onChangeSendAsFile}
              value={presenter.isSendMediaAsFile}
              isDisabled={presenter.isRecalculateProcess}
              label={t('attach_send_as_file')}
            />
          )}

          {presenter.canShowComment && (
            <TextFormattingInput
              className={styles.inputContainer}
              inputClassName={styles.input}
              placeholder={t('common_caption')}
              value={presenter.caption}
              onChange={presenter.onChange}
              onSubmit={presenter.onInputSubmit}
            />
          )}

          <Button
            setRef={popover.containerRef}
            className={styles.button}
            theme="primary"
            onClick={(): Promise<void> => presenter.onSubmit()}
            onContextMenu={onContextMenu}
          >
            {presenter.successTitle}
          </Button>
        </div>

        {presenter.isShowSubmitMenu && (
          <MediaMessageSubmitMenu
            popover={popover}
            onSubmit={presenter.onSubmit}
          />
        )}
      </Popup>
    );
  }
);
